import { SharedDocumalisModule } from '@documalis/shared-documalis.module';
import { NgModule } from '@angular/core';
import { AdminDelegateRoutes } from './admindelegate.routes';
import { ListAdminDelegateComponent } from './list-admindelegate/list-admindelegate.component';
import { FormAdminDelegateComponent } from './_components/form-admindelegate/form-admindelegate.component';
import { AddAdminDelegateComponent } from './add-admindelegate/add-admindelegate.component';
import { EditAdminDelegateComponent } from './edit-admindelegate/edit-admindelegate.component';
import { TranslateModule } from '@ngx-translate/core';
import {InputSwitchModule} from "primeng/inputswitch";

@NgModule({
    imports: [AdminDelegateRoutes, SharedDocumalisModule, TranslateModule, InputSwitchModule, FormAdminDelegateComponent],
    declarations: [ListAdminDelegateComponent, AddAdminDelegateComponent, EditAdminDelegateComponent],
})
export class AdminDelegateModule {}
